import { render, staticRenderFns } from "./MyCustomer.vue?vue&type=template&id=4593f252&scoped=true"
import script from "./MyCustomer.vue?vue&type=script&lang=js"
export * from "./MyCustomer.vue?vue&type=script&lang=js"
import style0 from "./MyCustomer.vue?vue&type=style&index=0&id=4593f252&prod&scoped=true&lang=scss"
import style1 from "./MyCustomer.vue?vue&type=style&index=1&id=4593f252&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4593f252",
  null
  
)

export default component.exports